import React from "react";
import { useSelector, useDispatch } from "react-redux";
import withStyles from "@material-ui/styles/withStyles";
import { useTranslation } from "react-i18next";
import { Grid } from "@material-ui/core";
import CustomForm from "../../../../common/components/CustomForm";

import { styles } from "./QuickSchedule.styles.js";
import { formFields, formSchema } from "./QuickSchedule.schema";

import { selectError, addScheduleInstance, selectLoader } from "../../schedulesSlice";

const buildSensorOptions = (structure, zoneId) => {
  let options = [];
  if (zoneId && structure) {
    let filteredStructure = structure.filter((item) => item.id === zoneId);
    if (filteredStructure && filteredStructure.length > 0) {
      filteredStructure[0].boxs.forEach((box) => {
        options.push({ text: box.designation });
        box.sensors.forEach((sensor) => {
          if (sensor.type === "RELAY") {
            options.push({ value: sensor.id, text: sensor.designation });
          }
        });
      });
    }
  }
  return options;
};

function QuickScheduleForm({ classes, onSubmit, selectedProject, payload, structure }) {
  const sensorOptions = buildSensorOptions(structure, payload?.zoneId);

  const { t } = useTranslation();
  const loader = useSelector(selectLoader);
  const error = useSelector(selectError);
  const dispatch = useDispatch();

  const onSubmitHandler = async (values) => {
    console.log("values: %o", values);
    dispatch(addScheduleInstance(selectedProject, values));
    onSubmit && onSubmit();
  };

  return (
    <Grid className={classes.root} container direction="row" justify="center" alignItems="center">
      <div>
        <CustomForm
          payload={payload}
          schema={formSchema(t)}
          fields={() => formFields(t, sensorOptions)}
          error={error}
          submitLabel={"Submit"}
          onSubmit={onSubmitHandler}
          submitting={Boolean(loader)}
        />
      </div>
    </Grid>
  );
}

export default withStyles(styles)(QuickScheduleForm);
